export default __webpack_public_path__ + "static/media/66input_1.340df8ac.png";